// export function isArray(o: any) {
//   return Object.prototype.toString.call(o) === "[object Array]";
// }

import Cookies from "js-cookie";
import { LocalLogin } from "../services/Models/AuthModel";
import { ColumnType, GridColumnType } from "../services/enums";
import { GridColType } from "@mui/x-data-grid-pro";

import {
  faFile,
  faFileAudio,
  faFileVideo,
  faFileZipper,
  faFileSignature,
  faFilePdf,
  faFileText,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFilePowerpoint,
  faFileXml,
  faFileCsv,
  faFileSlash,
  faFiles,
  faLink,
  faCloud,
  faFilm,
  IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

// export function isEmpty(o: any) {
//   if (o == null || o === "") return true;
//   if (isArray(o)) {
//     for (var i in o) return false;
//     return true;
//   }
//   return false;
// }

class util {
  public static get interfaceLanguage(): string {
    const localInfo: LocalLogin = getLogonInfoFromCookies();
    // const result = JSON.parse(
    //   localStorage.getItem("LoginResult") !== "null"
    //     ? localStorage.getItem("LoginResult")!
    //     : '{"Language" : "' + (navigator.language ?? "it") + '"}'
    // );
    let languageCode = localInfo
      ? localInfo.Language ?? navigator.language ?? "it"
      : navigator.language ?? "it";
    if (languageCode.includes("-")) {
      languageCode = languageCode.split("-")[0];
    }
    switch (languageCode) {
      case "es":
      case "en":
      case "de":
      case "fr":
      case "ro":
        return languageCode;
      default:
        return "it";
    }
  }
}
export function isBackwardNavigation() {
  return window.location.href.indexOf("back=1") >= 0;
}

//  public static convertColumnType(colType: ColumnType): GridColType {
export function convertColumnType(colType: ColumnType): GridColType {
  switch (colType) {
    case ColumnType.Unknown:
      return GridColumnType.Unknown;
    case ColumnType.BooleanType:
      return GridColumnType.BooleanType;
    case ColumnType.DateTimeType:
      return GridColumnType.DateTimeType;
    case ColumnType.IntegerType:
      return GridColumnType.IntegerType;
    case ColumnType.DecimalType:
      return GridColumnType.DecimalType;
    case ColumnType.ShortTextType:
      return GridColumnType.ShortTextType;
    case ColumnType.LongTextType:
      return GridColumnType.LongTextType;
    case ColumnType.EnumListType:
      return GridColumnType.EnumListType;
    case ColumnType.ObjectListType:
      return GridColumnType.ObjectListType;
    default:
      return GridColumnType.ShortTextType;
  }
}
export function returnIconExtension(extension: string | null): IconDefinition {
  if (extension === null) return faFiles;
  extension = String(extension).replace(/\./g, "");
  const num = Number(extension);
  if (!isNaN(num) && num >= 1 && num <= 999 && Number.isInteger(num))
    extension = "zip";

  switch (extension.toUpperCase()) {
    case "":
      return faFileSlash;
    case "7Z":
    case "ACE":
    case "ARC":
    case "ARK":
    case "ARJ":
    case "LHA":
    case "LZH":
    case "PAR":
    case "RAR":
    case "SITX":
    case "ZIM":
    case "ZIP":
    case "ZIPX":
      return faFileZipper;
    case "AAC":
    case "AC3":
    case "AIF":
    case "AIFF":
    case "AIFC":
    case "APE":
    case "AMR":
    case "BWF":
    case "CDA":
    case "DTS":
    case "FLAC":
    case "MIDI":
    case "MOD":
    case "MP3":
    case "OGA":
    case "OGG":
    case "OPUS":
    case "PCA":
    case "RA":
    case "RAM":
    case "S3M":
    case "SFA":
    case "W64":
    case "WAV":
    case "WAVE":
    case "WMA":
    case "XM":
      return faFileAudio;
    case "3GP":
    case "ASF":
    case "AVI":
    case "DIVX":
    case "F4A":
    case "F4B":
    case "F4P":
    case "F4V":
    case "FLV":
    case "MP2":
    case "MPG":
    case "MPEG":
    case "M4A":
    case "M4B":
    case "M4P":
    case "M4R":
    case "M4V":
    case "MP4":
    case "OGM":
    case "OGV":
    case "OGX":
    case "WMV":
    case "MOV":
    case "QT":
    case "MKV":
    case "MKA":
    case "MKS":
    case "MK3D":
    case "WEBA":
    case "WEBM":
    case "RM":
    case "VOB":
    case "XVID":
      return faFileVideo;
    case "BMP":
    case "DIB":
    case "CPD":
    case "DJVU":
    case "DJV":
    case "GIF":
    case "GPD":
    case "JPD":
    case "JPG":
    case "JIF":
    case "JPE":
    case "JFI":
    case "JPEG":
    case "JFIF":
    case "JP2":
    case "J2K":
    case "JPF":
    case "JPX":
    case "JPM":
    case "MJ2":
    case "PNG":
    case "TGA":
    case "ICB":
    case "VDA":
    case "VST":
    case "TIF":
    case "TIFF":
    case "PCX":
    case "PSD":
    case "WEBP":
      return faFileImage;
    case "PTM":
    case "P7S":
    case "P7C":
    case "XADES":
    case "P12":
    case "PFX":
    case "TSR":
    case "TST":
    case "SIG":
    case "CSR":
    case "CER":
    case "P7M":
    case "ASICE":
    case "SCE":
    case "ADOC":
    case "CRT":
    case "KEY":
      return faFileSignature;
    case "CSV":
      return faFileCsv;
    case "PDF":
      return faFilePdf;
    case "XML":
      return faFileXml;
    case "TXT":
    case "TEXT":
      return faFileText;
    case "DOC":
    case "DOCX":
    case "DOT":
    case "DOTX":
    case "ODT":
    case "OTT":
    case "FODT":
    case "SXW":
      return faFileWord;
    case "XLS":
    case "XLSX":
    case "XLSM":
    case "XLT":
    case "XLTS":
    case "XLTM":
    case "XLSB":
    case "ODS":
    case "OTS":
    case "FODS":
      return faFileExcel;
    case "PPT":
    case "PPTX":
    case "PPTM":
    case "POT":
    case "POTX":
    case "POTM":
    case "PPS":
    case "PPSX":
    case "PPSM":
    case "ODP":
    case "OTP":
    case "FODP":
      return faFilePowerpoint;
    case "LINK":
      return faLink;
    case "AZURE":
      return faCloud;
    case "YOUTUBE":
      return faFilm;
    default:
      return faFile;
  }
}
export function isVideo(extension: string | null): boolean {
  if (extension === null) return false;
  extension = String(extension).replace(/\./g, "");
  switch (extension.toUpperCase()) {
    case "3GP":
    case "ASF":
    case "AVI":
    case "DIVX":
    case "F4A":
    case "F4B":
    case "F4P":
    case "F4V":
    case "FLV":
    case "MP2":
    case "MPG":
    case "MPEG":
    case "M4A":
    case "M4B":
    case "M4P":
    case "M4R":
    case "M4V":
    case "MP4":
    case "OGM":
    case "OGV":
    case "OGX":
    case "WMV":
    case "MOV":
    case "QT":
    case "MKV":
    case "MKA":
    case "MKS":
    case "MK3D":
    case "WEBA":
    case "WEBM":
    case "RM":
    case "VOB":
    case "XVID":
      return true;
    default:
      return false;
  }
}

// }

export function getFileExtension(
  url: string,
  noPoint?: boolean
): string | null {
  const parts = url.split(".");
  return parts.length > 1
    ? (noPoint ? "" : ".") + parts.pop() || (noPoint ? "" : null)
    : noPoint
    ? ""
    : null;
}

export const getFullLocale = (shortLocale: string) => {
  const localeMap: Record<string, string> = {
    it: "it-IT", // Italiano
    en: "en-US", // Inglese
    fr: "fr-FR", // Francese
    de: "de-DE", // Tedesco
    es: "es-ES", // Spagnolo
    // Aggiungi altre lingue qui se necessario
  };

  // Ritorna la lingua completa se mappata, altrimenti usa la lingua corta con una regione di default
  return localeMap[shortLocale] || "it-IT"; // Default "en-US" se la lingua non è mappata
};

export const saveLogonInfoToCookies = (info: LocalLogin) => {
  Cookies.set("logon_info", JSON.stringify(info), { expires: 7 }); // Cookie valido per 7 giorni
};

export const deleteLogonInfoFromCookies = () => {
  Cookies.remove("logon_info");
};

// Funzione per leggere logon_info dai cookies
export const getLogonInfoFromCookies = () => {
  const cookieData = Cookies.get("logon_info");
  if (cookieData) {
    return JSON.parse(cookieData ?? "null") as LocalLogin;
  } else return JSON.parse("null") as LocalLogin;
};

export function returnError(result: any): string {
  if (result && result.ResultCode === "ERROR") {
    if (result.DetailedMessage) {
      const pos = result.DetailedMessage.indexOf("Description:");
      if (pos >= 0) return result.DetailedMessage.substring(pos + 12).trim();
      else return result.DetailedMessage;
    } else return "errore interno";
  } else return "errore interno";
}

export default util;
